<div class="text-right mb-2">
  <div *ngIf="isDisabled" class="button text-uppercase btn-green" (click)="isDisabled=false">{{"EDIT_ORDER" |translate}}</div>
  <span *ngIf="!isDisabled">
    <div class="button text-uppercase btn-grey mr-3" (click)="isDisabled=true">{{"CANCEL" |translate}}</div>
    <div class="button text-uppercase btn-green" (click)="saveOrdering()">{{"SAVE" |translate}}</div>
  </span>
</div>
<div>
  <div cdkDropList #pendingList="cdkDropList" [cdkDropListData]="homeIds" (cdkDropListDropped)="drop($event)">
    <div class="row-drag flex-space-between" *ngFor="let id of homeIds" cdkDrag [cdkDragDisabled]="isDisabled">
      <span class="row-content">
        <img class="mr-3 cursor-drag d-inline-b v-middle" *ngIf="!isDisabled" src="./assets/img/drag.svg" width="16">
        <div class="d-inline-b v-middle">
          <div *ngFor="let item of getHomeById(id); let last = last" [ngClass]="{'mb-2': !last}">
            <img [src]="getFlag(item.lang)" width="20">
            {{item.description}}
          </div>
        </div>
      </span>
      <span>
        <img class="ml-3 mr-3 cursor" src="./assets/img/pencil.svg" width="20"  (click)="showModalEdit(id)">
        <img class="cursor" (click)="showModalDelete(id)" src="./assets/img/delete.svg" width="20">
      </span>
    </div>
  </div>

  <!-- <div class="row-stripe flex-space-between" *ngFor="let id of homeIds">
    <span class="row-content v-top">
      <div *ngFor="let item of getHomeById(id); let last = last" [ngClass]="{'mb-2': !last}">
        <img [src]="getFlag(item.lang)" width="20">
        {{item.description}}
      </div>
    </span>
    <span class="v-top">
      <img class="ml-3 mr-3 cursor" src="./assets/img/pencil.svg" width="20"  (click)="showModalEdit(id)">
      <img class="cursor" (click)="showModalDelete(id)" src="./assets/img/delete.svg" width="20">
    </span>
  </div> -->
</div>


<div class="modal modal-item" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title flex-space-between">
          {{"EDIT_ITEM" | translate}}
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text pt-4">
          <div *ngFor="let item of getHomeById(selectedId)" class="flex-space-between mb-2">
            <img [src]="getFlag(item.lang)" width="30" class="mr-2">
            <input type="text" [(ngModel)]="item.description" />
          </div>
          <!-- <img [src]="getCustomerById(selectedId)[0].image" /> -->
        </div>
      </div>
      <div class="modal-footer">
        <div class="button btn-grey text-uppercase" data-dismiss="modal">{{"CANCEL" | translate}}</div>
        <div class="button btn-green text-uppercase" data-dismiss="modal" (click)="update()">OK</div>
      </div>
    </div>
  </div>
</div>

<div class="modal delete-item" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title red flex-space-between">
          {{"DELETE_ITEM" | translate}}
          <img class="cursor" src="assets/img/close.svg" width="10" data-dismiss="modal">
        </div>
        <div class="modal-text pt-4">
          {{"SURE_TO_DELETE" | translate}}
          <span *ngFor="let item of getHomeById(selectedId)">
            <span class="bold" *ngIf="item.lang=='it-IT'">{{item.description}}</span>
          </span>?
        </div>
      </div>
      <div class="modal-footer">
        <div class="button btn-grey text-uppercase" data-dismiss="modal">{{"CANCEL" | translate}}</div>
        <div class="button btn-green text-uppercase" data-dismiss="modal" (click)="deleteHome()">OK</div>
      </div>
    </div>
  </div>
</div>